// Hash estável de 32 bits (FNV-1a): escolhe nome, personagem e variações pelo id,
// sempre igual para o mesmo id. Usado no servidor e no navegador.

export function stableHash(value: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < value.length; i++) {
    hash ^= value.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash >>> 0;
}
